import React from 'react';
import Paper from 'material-ui/Paper';
import 'styles/call-card/sync-crm/CallCRMRecord.styl';

import ViewInSalesforceBlue from 'images/card/SalesforceBlue.svg';
import ViewInSalesforceGray from 'images/card/SalesforceGray.svg';
import ResyncSalesforceBlue from 'images/card/ResyncBlue.svg';
import ResyncSalesforceGray from 'images/card/ResyncGray.svg';

const customPaperStyle = {
  height: '80px',
};

/**
 * CallSyncCRMPaperButton renders a <Paper/> based button that can serves as a sub-component inside
 * <CallSyncCRMRecordDialog/>
 */
class CallSyncCRMPaperButton extends React.Component {
  constructor() {
    super();
    this.state = {
      isMouseHover: false,
    };
    this.onMouseEnter = this.onMouseEnter.bind(this);
    this.onMouseLeave = this.onMouseLeave.bind(this);
    this.onTouchTap = this.onTouchTap.bind(this);
  }

  onMouseEnter() {
    this.setState({isMouseHover: true});
  }

  onMouseLeave() {
    this.setState({isMouseHover: false});
  }

  /**
   * Return the image file to use in the center of the <Paper/> element depending on which imageName this component is
   * assigned to and whether the mouse is hovering over this component or not
   * :return image: image object to be used
   */
  imageToUse() {
    if (this.props.imageName === 'view-in-salesforce') {
      if (this.state.isMouseHover) {
        return ViewInSalesforceBlue;
      }
      return ViewInSalesforceGray;
    } else if (this.props.imageName === 'resync-salesforce') {
      if (this.state.isMouseHover) {
        return ResyncSalesforceBlue;
      }
      return ResyncSalesforceGray;
    }
  }

  /** Call the parent component to handle the touch tap event of the whole <div/> */
  onTouchTap() {
    this.props.onTouchTapCRMPaperButton(this.props.imageName);
  }

  render() {
    const image = this.imageToUse();
    return (
      <div
        className={this.props.outerDivClassName}
        onMouseEnter={this.onMouseEnter}
        onMouseLeave={this.onMouseLeave}
        onClick={this.onTouchTap}>
        <Paper style={customPaperStyle}>
          <img alt="center" src={image} className="center-img" />
        </Paper>
        <p className="caption first-line">{this.props.firstLine}</p>
        <p className="caption second-line salesforce-color">Salesforce</p>
      </div>
    );
  }
}

export default CallSyncCRMPaperButton;
